import { Controller } from "react-hook-form";
import DTextField from "components/common/DTextField";

export default function RHFSelect({ name, control, options = [], ...props }) {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <DTextField
                    {...field}
                    {...props}
                    select
                    options={options}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                />
            )}
        />
    );
}
